import React, { Component } from 'react';

import Dropdown from 'common/components/generic/Dropdown';

class FilterList extends Component {
  constructor(props, context) {
    super(props, context);
    this.placeholder = document.getElementById('filter-entity');
    this.element = {};
    this.LIST_TYPE = 'section';
    this.SELECTED_TYPE = 'selected';

    this.getSection();
    this.getSelected();
    this.element.all = this.element.selected.concat(this.element.section);
  }

  getSection() {
    const section =
      this.placeholder.getElementsByClassName('filter-entity-word');
    const l = section.length;
    let i;

    this.element.section = [];

    for (i = 0; i < l; i++) {
      const item = section[i];
      const href = item.getElementsByClassName('item-content');

      this.element.section.push({
        type: this.LIST_TYPE,
        name: item.getAttribute('data-name'),
        href: []
      });

      for (const link of href) {
        const obj = { value: link.href, label: link.getAttribute('title') };
        this.element.section[i].href.push(obj);
      }
    }
  }

  getSelected() {
    const selected =
      this.placeholder.getElementsByClassName('filter-entity-on');
    const l = selected.length;
    let i;

    this.element.selected = [];

    for (i = 0; i < l; i++) {
      const item = selected[i];
      const label = item
        .getElementsByClassName('filter-entity-on-txt')[0]
        .getAttribute('data-name');
      const link = item.getElementsByClassName('item-content')[0].href;

      this.element.selected.push({
        type: this.SELECTED_TYPE,
        name: item.getAttribute('data-name'),
        href: [{ value: link, label: label }]
      });
    }
  }

  handleSelectChange(event) {
    window.location.href = event.target.value;
  }

  renderSelect(obj, index) {
    const options = obj.href.map(function options(item) {
      return (
        <option key={item.value} value={item.value}>
          {item.label}
        </option>
      );
    });

    return (
      <Dropdown onChange={this.handleSelectChange.bind(this)} key={index}>
        <option value="">{obj.name}</option>
        {options}
      </Dropdown>
    );
  }

  renderLink(obj, index) {
    const link = obj.href.map(function link(item) {
      return (
        <div className="dropdown-selected-value" key={index}>
          <div className="filter dropdown-selected-value-inner">
            <strong>{obj.name} : </strong>
            {item.label}
            <a
              href={item.value}
              className="dropdown-selected-value-close-link icon icon-cross-a"
            />
          </div>
        </div>
      );
    });

    return link;
  }

  renderAllFilter() {
    const filterBar = this.element.all.map(
      function filter(item, index) {
        if (item.type === this.SELECTED_TYPE) {
          return this.renderLink(item, index);
        }
        return this.renderSelect(item, index);
      }.bind(this)
    );

    return filterBar;
  }

  render() {
    return <div className="filter-entity-select">{this.renderAllFilter()}</div>;
  }
}

export default FilterList;
